<template>
  <div class="basic_wrap user-page records-page">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('moneybag.myWallet') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/moneybag')"
      >
        <van-icon
          name="filter-o"
          size="25"
        />
      </div>
    </div>
	
        
    <div class="detail_box">
      <van-empty
        v-if="listShow"
        :description="$t('item.noData')"
      />
      <div
        v-for="item in data"
        :key="item.id"
        class="item"
      >
        <div class="de_wrap">
          <p class="tit">
            {{ item[lang] }}
          </p>
          <template v-if="item.remark!=''">
            <p class="time">
              {{ $t('cash.remark') }}:{{ item.remark }}
            </p>
          </template>
          <p class="time">
            {{ item.time }}
          </p>
        </div>
        <div
          class="price"
          :class="item.type =='1'?'':'del'"
          v-html="item.type =='1'?$formatPen(item.money) : '-'+$formatPen(item.money)"
        />
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem);

    export default {
        name: "WithdrawRecord",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: [],
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                mymoney: 0,
                userName:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/funds',{
                reason_id: 2
            }).then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                
                this.showError(r.data.list.length);
                this.data = r.data.list;
				if(this.data.length>0){
					for (let i = 0; i < this.data.length; i++) {
						this.data[i].time = new Date(this.data[i].time).getTime();
						console.log(new Date(this.data[i].time).getTime())
					}
				}
				
                this.funds = r.data.money;
                this.mymoney = r.data.mymoney;
                this.userName = r.data.username;
            })
        },
        methods: {
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .records-page {
        min-height: 100vh;
        box-sizing: border-box;
        padding-bottom: calc(var(--app-bottom-menu-height) + 24px + env(safe-area-inset-bottom, 0px));
        background: #f5f5f5;
        color: #333;
    }
    .red_top_bg {
        height: 50px;
        background: #fff;
        position: relative;
        border-bottom: 1px solid #eceff2;
        color: #101827;
    }
	.back_left { filter: brightness(0); opacity: 1; }
	.big_tit { top: 13px; font-size: 16px; font-weight: 500; color: #333; }
	.top_right { top: 12px; color: #ee4d2d; }
	.user_yw{
		text-align: center;
		width: 96%;
		position: absolute;
		top: 78px;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 20px 0;
        display: flex;
        div{
            width: 50%;
        }
		p:nth-child(1){
			font-size: 16px;
			color: #646566;
			margin-bottom: 20px;
		}
		p:nth-child(2){
			font-size: 20px;
			font-weight: bold;
		}
	}
	.user_zrzc{
		text-align: center;
		width: 96%;
		position: absolute;
		top: 173px;
		background: #FFFFFF;
		left: 2%;
		border-radius: 0 0 5px 5px;
		padding: 15px 0;
		display: flex;
		justify-content: space-between;
		text-align: center;
		span{
			width: 40%;
			background: #3775f4;
			color: #FFFFFF;
			margin: 0px 20px;
			padding: 12px 10px;
			border-radius: 5px;
		}
	}

    .detail_box {
        width: auto;
		margin: 16px;
        overflow: hidden;
        background: #fff;
        border-radius: 0;
        padding: 0 12px;
		box-shadow: none;
		/deep/ .van-empty { padding: 44px 0; }
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding: 16px 4px;
            border-bottom: 1px solid #edf0f2;
			&:last-child { border-bottom: 0; }

            .de_wrap {
                flex: 2;
				min-width: 0;

                .tit {
                    font-size: 13px;
                    color: #333;
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: #888;
                    line-height: 17px;
                    margin-top: 6px;
					word-break: break-word;
                }
            }

            .price {
                flex: 1;
                font-size: 14px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #ee4d2d;
                white-space: nowrap;
                &.del {
                    color: #3f9b62;
                }
            }
        }
    }
	.records-page { background: #f5f5f5; }
	.detail_box { margin: 10px 0 0; padding: 0 16px; border-radius: 0; }
	.detail_box .item { min-height: 64px; padding: 14px 0; }
	.detail_box .item .de_wrap .tit { font-weight: 500; }
	.detail_box .item .price { font-size: 15px; }
</style>
